import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from './authentication/authentication.guard';
import { ActivateGuard } from './activate.guard';

const routes: Routes = [
  {
    path: 'authentication',
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'dashboard',
    canActivate: [ActivateGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'no-page/:id',
    loadChildren: () =>
      import('./no-page/no-page.module').then((m) => m.NoPageModule),
  },
  { path: 'maintenance', redirectTo: 'no-page/maintenance', pathMatch: 'full' },
  { path: 'offline', redirectTo: 'no-page/offline', pathMatch: 'full' },
  { path: 'bug', redirectTo: 'no-page/bug', pathMatch: 'full' },
  { path: '404', redirectTo: 'no-page/404', pathMatch: 'full' },
  { path: '', redirectTo: 'authentication', pathMatch: 'full' },
  { path: '**', redirectTo: 'no-page/404', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
